/**
 * @voltxampere/ui — 10-turn trim potentiometer (Sprint 50-8)
 *
 * Bourns 3296W-style 10-turn trim potentiometer for precision
 * tuning. Common values: 100Ω/1kΩ/10kΩ/100kΩ/1MΩ. Used in voltage
 * reference adjustment, op-amp offset null, calibration circuits.
 *
 * Reference: Bourns 3296W datasheet (3296_doc.pdf, 2018).
 *
 * Engine zero-diff invariant honored — schemaType `potentiometer`
 * (Sprint 23 B4 canonical type, 3-pin top/wiper/bottom).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { resistor } from "../resistor.js";
export const potTrim10Turn = {
    id: "trim-pot-10t",
    nameTr: "Trim Potansiyometre (10-tur, hassas)",
    nameEn: "Trim Potentiometer (10-turn, precision)",
    shortcut: "P",
    category: "passive",
    viewBox: resistor.viewBox,
    terminals: resistor.terminals,
    defaultLabel: "RV",
    defaultValue: "10kΩ",
    schemaType: "potentiometer",
    defaultParams: {
        resistance: 10000,
        wiperPosition: 0.5,
        turnsPerRotation: 10,
        package: "Bourns 3296W",
        tolerancePercent: 10,
    },
    renderSVG: () => resistor.renderSVG(),
};
//# sourceMappingURL=pot-trim-10-turn.js.map